/* eslint no-loop-func: 1 */
import mori from 'mori';

/**
 * A reducer that unfolds the default datatypes map so we can look up
 * all possible types and their parent.
 * @param {object} defaultDatatypes - An object containing parent type keys
 *  and arrays of input options
 * @return {array} An array of tuples containing child and parent
 */
export function getHeaderDataTypes(defaultDatatypes) {
  return mori.intoArray(mori.transduce(
    mori.mapcat((x) => {
      if (mori.first(mori.rest(x))) {
        return mori.intoArray(mori.transduce(
          mori.map((y) => {
            return [y, mori.first(x)];
          }),
          mori.completing(mori.conj),
          mori.vector([mori.first(x), mori.first(x)]), // start with the parent
          mori.first(mori.rest(x))
        ));
      }
      return [[mori.first(x), mori.first(x)]];
    }),
    mori.completing(mori.conj),
    mori.vector(),
    mori.toClj(defaultDatatypes)
  ));
}

/**
 * A transducer that slices the header rows from the given datasheet
 * @param {array} sheet - A datasheet from the gdoc
 * @return {array} An array of only header rows
 */
export function getHeadersOnly(sheet) {
  return mori.intoArray(
    mori.takeWhile((x) => !x[0] || x[0].toLowerCase() === 'location', sheet)
  );
}

export function getHeaderTypeObject(type, types) {
  if (!type) {
    return false;
  }

  const typeSplit = type.split('--');
  const typeValue = typeSplit.length === 2 &&
    ['narrow', 'wide'].indexOf(typeSplit[1].toLowerCase()) > -1 ?
      typeSplit[0] : type;
  const mappedType =
    types.filter((x) => x[0] === typeValue.toLowerCase()).shift();

  if (mappedType) {
    return {
      type: mappedType[1],
      label: typeValue,
      width: (typeSplit[1] || '').toLowerCase(),
    };
  }

  return false;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/transducerUtils/headerUtils.js